import React from 'react';
import './Loader.css';

const PageLoader = () => {
  return (
    <div className="loader-container">   
      <div className="page-loader-blk">
        <div className="dot1"></div>
        <div className="dot2"></div>
        <div className="dot3"></div>
      </div>
    </div>
    
  
  );
};

export default PageLoader;